import { render, staticRenderFns } from "./ThePersonalDiscounts.vue?vue&type=template&id=1d64e8be&"
import script from "./ThePersonalDiscounts.vue?vue&type=script&lang=js&"
export * from "./ThePersonalDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalDiscounts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports